// The three-step progress bar above every page. `active` is 1, 2 or 3.
export default function StatusLine({ steps, active }) {
  return (
    <div id="statusLine">
      <div className="statusLineBorder">
        <div className={`stepFrameFirst${active === 1 ? " stepFrameActive" : ""}`}>
          <div className={active === 1 ? "stepTextActive" : "stepTextPre"}>{steps[0]}</div>
        </div>
        <div className="stepPic">
          <div className={`triangle${active > 1 ? " triangle_white" : ""}`} />
          <div className={active > 1 ? "top-triangle-brown" : "top-triangle"} />
          <div className={active > 1 ? "bottom-triangle-brown" : "bottom-triangle"} />
        </div>
        <div className={`stepFrame${active === 2 ? " stepFrameActive" : ""}`}>
          <div className={active === 2 ? "stepTextActive" : "stepTextPre"}>{steps[1]}</div>
        </div>
        <div className="stepPic">
          <div className={`triangle${active > 2 ? " triangle_white" : ""}`} />
          <div className={active > 2 ? "top-triangle-brown" : "top-triangle"} />
          <div className={active > 2 ? "bottom-triangle-brown" : "bottom-triangle"} />
        </div>
        <div className={`stepFrameLast${active === 3 ? " stepFrameActive" : ""}`}>
          <div className={active === 3 ? "stepTextActive" : "stepTextPre"}>{steps[2]}</div>
        </div>
      </div>
    </div>
  );
}
